import { useEffect, type RefObject } from 'react'

/** Closes an open dropdown when the user interacts anywhere outside its
 * container — including clicking a sibling top-bar control. Listens on
 * `mousedown` (fires before the target's own `click` handler), so opening a
 * different menu closes this one first instead of both staying open at once.
 */
export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  onOutside: () => void,
  active: boolean
) {
  useEffect(() => {
    if (!active) return
    function handle(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onOutside()
      }
    }
    document.addEventListener('mousedown', handle)
    return () => document.removeEventListener('mousedown', handle)
  }, [active, ref, onOutside])
}
